var _path, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPurpleAbout(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 336,
    height: 192,
    viewBox: "0 0 336 192",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M175.621 180.123C151.697 255.124 -48.881 -64.1047 11.7419 -18.8292C171.731 100.657 124.491 -42.0721 154.573 -49.51L154.611 -49.5326C154.57 -49.5152 154.525 -49.4963 154.644 -49.5517C154.644 -49.55 154.645 -49.5482 154.645 -49.5465C187.473 70.4752 295.062 -33.0561 325.448 -16.3089C363.431 4.62551 279.03 55.3167 235.164 69.43C191.299 83.5433 188.138 140.881 175.621 180.123Z",
    fill: "url(#paint0_linear_619_1578)",
    fillOpacity: 0.25
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_619_1578",
    x1: 319.731,
    y1: -55.5242,
    x2: 7.37641,
    y2: 47.0215,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7750BF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7750BF",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPurpleAbout);
export default __webpack_public_path__ + "static/media/PurpleAbout.9b10fa336d785c2153c09c74ac13b2e5.svg";
export { ForwardRef as ReactComponent };